import { Footer } from '@/previewThemes/tumble/Footer';
import { Header } from '@/previewThemes/tumble/Header';
import { Product } from '@/previewThemes/tumble/Product';
import { tumbleProductParts, tumbleProductSections } from '@/previewThemes/tumble/productPage';
import type { ThemePackage } from '@/previewThemes/types';

export const theme: ThemePackage = {
  Header,
  Footer,
  Product,
  // The cart opens as a drawer from the right - from the header's cart link
  // and after "Add to cart" - so a parent filling a basket never loses the
  // shelf they were browsing.
  quickCart: true,
  listing: {
    // Three across, with the filters in a row of chips above: a toy shelf is
    // browsed by picture, and three rounded tiles across the full width are
    // big enough to see the toy, not just its box.
    grid: 'grid-cols-2 gap-5 lg:grid-cols-3 lg:gap-7',
    filters: 'chips',
    columns: 3,
    // Every card sits in a rounded, outlined tile - the picture above, the
    // name and the price below it.
    card: 'framed',
  },
  cart: { grid: 'mt-8 grid gap-8 lg:grid-cols-3', panel: 'filled' },
  checkout: {
    grid: 'mt-8 grid items-start gap-8 lg:grid-cols-[minmax(0,1fr)_24rem] lg:gap-12',
    panel: 'filled',
  },
  search: {
    grid: 'mt-8 grid gap-8 lg:grid-cols-[240px_1fr]',
    results: 'grid grid-cols-2 gap-5 lg:grid-cols-3',
    columns: 3,
    card: 'framed',
    // The facet rail sits on the lavender, so the filters read as one soft
    // block beside the results.
    panel: 'filled',
  },
  blog: { list: 'grid gap-8 sm:grid-cols-2 lg:grid-cols-3', title: 'text-2xl' },
  // Departments as picture cards, the name on the card under each.
  category: { grid: 'grid gap-5 sm:grid-cols-2 lg:grid-cols-4', tile: 'card' },
  pages: {
    product: { defaults: tumbleProductSections },
  },
  parts: {
    product_details: {
      defaults: tumbleProductParts,
      presentation: {
        classes: {
          product_title: 'text-3xl sm:text-4xl leading-tight',
          product_price: 'text-2xl font-bold',
          product_short_description: 'text-[15px]',
        },
        wideButtons: true,
        gallery: { aspect: 'square', thumbs: 'below' },
      },
    },
  },
};
